import { useTranslation } from "react-i18next";
import {
    ColumnButtons,
    ColumnDivider,
    SubnavPanelBody,
    IconNavItem,
    NavCard,
    NavColumn,
} from "~/components/header/full-header/subnavigation/common";
import { DEVELOPER_DOCS_URL, HELP_CENTER_URL, STATUS_URL } from "~/lib/external-links";
import { imageUrl } from "~/lib/image-url";
import { useOpenObdCompatibilityChecker } from "~/components/products/pdp/ObdCompatibilityCheckerContext";

// Plain public/ string path, not a JS import — see the comment on bgImageSet in
// app/components/home/UseCases.tsx for why.
const resourcesCardImg = imageUrl("/images/subnav/resources-vehicle-tracking.jpg");

export default function ResourcesNavItem({ onNavigate }: { onNavigate: () => void }) {
    const { t } = useTranslation("common");
    const openObdChecker = useOpenObdCompatibilityChecker();

    const support: IconNavItem[] = [
        { name: t("subnav.resources.help_center"),     href: HELP_CENTER_URL,              external: true },
        { name: t("subnav.resources.system_status"),   href: STATUS_URL, external: true },
        // Opens the site-wide Compatibility Checker drawer (mounted in root.tsx).
        { name: t("subnav.resources.find_my_obd_port"), href: "#", onClick: openObdChecker },
    ];

    const company: IconNavItem[] = [
        { name: t("subnav.resources.blog"),        href: "https://www.bouncie.com/blog", external: true },
        { name: t("subnav.resources.careers"),     href: "/careers" },
        { name: t("subnav.resources.collaborate"), href: "/big-idea" },
    ];

    const developers: IconNavItem[] = [
        { name: t("subnav.resources.api"),  href: DEVELOPER_DOCS_URL, external: true },
        { name: t("subnav.resources.docs"), href: DEVELOPER_DOCS_URL, external: true },
    ];

    return (
        <SubnavPanelBody>
            <div className="flex items-start justify-center gap-20">
                <div className="flex items-start gap-4">
                    <NavColumn header={t("subnav.resources.col_support")} className="w-[152px]">
                        <ColumnButtons onNavigate={onNavigate} buttonData={support}/>
                    </NavColumn>
                    <ColumnDivider />
                    <NavColumn header={t("subnav.resources.col_company")} className="w-[140px]">
                        <ColumnButtons onNavigate={onNavigate} buttonData={company}/>
                    </NavColumn>
                    <ColumnDivider />
                    <NavColumn header={t("subnav.resources.col_developers")} className="w-[140px]">
                        <ColumnButtons onNavigate={onNavigate} buttonData={developers}/>
                    </NavColumn>
                </div>
                <NavCard
                    className="w-[247px]"
                    image={resourcesCardImg}
                    title={t("subnav.resources.card_title")}
                />
            </div>
        </SubnavPanelBody>
    );
}
